<template>
    <div>
      <header>
        公司：
        <el-input
          v-model="companyName"
          placeholder="请输入关键字搜索"
          style="width: 200px;margin-right: 10px;"
        ></el-input>项目：
        <el-input
          v-model="projectName"
          placeholder="请输入关键字搜索"
          style="width: 200px;margin-right: 10px;"
        ></el-input>
        类别：
        <el-select
        v-model="type"
        placeholder="请选择类别"
        filterable
      >
        <el-option
          v-for="pro in [
                { value: 0, label: '请选择类别' },
                ...options,
              ]"
          :key="pro.value"
          :label="pro.label"
          :value="pro.value"
        >
        </el-option>
      </el-select>
        状态：
        <el-select
          v-model="enable"
          placeholder="请选择状态"
        >
        <el-option
          v-for="pro in options2"
          :key="pro.value"
          :label="pro.label"
          :value="pro.value"
        >
        </el-option> </el-select>
        <el-button
          type="primary"
          icon="el-icon-search"
          style="margin-left: 10px"
          @click="getList()"
        >查询</el-button>
        <el-button
          type="primary"
          style="margin-left: 10px"
          @click="openDialog(null)"
        >新增</el-button>
      </header>
      <el-table
        :data="tableData"
        border
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column
          prop="name"
          label="公司/项目名称"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="specificTypeName"
          label="类别"
          width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="actionUrl"
          label="地址"
          align="center"
        ></el-table-column>
        <el-table-column
        prop="status"
          label="状态"
          align="center"
        >
        </el-table-column>
        <el-table-column
        label="操作"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="openEdit(scope.row)"
          >查看</el-button>
          <el-button
            type="text"
            @click="del(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div
      class="tc"
      style="margin-top:20px"
    >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[ 10, 20, 50]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>
      <addDialog
      ref="addDialog"
      @updateList="getList"
    />
    <editDialog
      ref="editDialog"
      @updateList="getList"
    />
    </div>
  </template>
  
  <script>
  import editDialog from './customized/editDialog.vue'
  import addDialog from './customized/addDialog.vue'
  import { Api_SuperAdmin } from "@/api/api";
  import { getStore } from "@/util/store";
  export default {
    components: {
        addDialog,
        editDialog },
    data() {
      return {
    options: [{value:1,label:'公司'},{value:2,label:'项目'}],
    options2: [{value:null,label:'请选择状态'},{value:true,label:'启用'},{value:false,label:'禁用'},],
    totalCount:0,
    currentPage:1,
        pagesize: 10,
        companyName:"",
        projectName:"",
        type:0,
        enable:null,
        tableData: [],
        companyId: "",
        projectId: getStore({ name: "projectId" }),
      };
    },
    created() {
      this.getList();
    },
    methods: {
        openDialog(row) {
      this.$refs.addDialog.open(row)
    },
    openEdit(row){
      this.$refs.editDialog.open(row)
    },
    del(item) {
      this.$confirm("是否删除此条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        Api_SuperAdmin.delCustomized(item.id).then((res) => {
          const { data } = res
          if (data.statusCode === 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getList();
          } else {
            this.$showMessage("失败", data.errors);
          }

        });
      });
    },
      getList() {
        let params = {
          pageSize: this.pagesize,
          pageIndex: this.currentPage,
          companyName: this.companyName,
          projectName: this.projectName,
          type: this.type,
          enable: this.enable,
        }
        if(this.enable===null){
          delete params.enable
        }
        Api_SuperAdmin.getCustomizedList(params).then((res) => {
          this.tableData = res.data.data.tList;
          this.totalCount = res.data.data.totalCount;
          this.tableData.forEach((ele)=>{
            if(ele.isEnable){
                ele.status='启用'
            }else{
                ele.status='禁用'
            }
          })
        });
      },
      handleSizeChange(size) {
        this.pagesize = size;
        this.getList();
      },
      handleCurrentChange(currentPage) {
        this.currentPage = currentPage;
        this.getList();
      },

    },
  };
  </script>
  <style lang="scss" scoped>
  .pushInformation {
    width: 100px;
    height: 30px;
    padding: 0 10px;
    background-color: #169bd5;
    cursor: pointer;
    border: none;
    border-radius: 3px;
    color: #fff;
    /deep/ .el-tooltip__popper {
      width: 200px;
    }
  }
  </style>
  <style>
  .groupLists .el-checkbox {
    width: 20%;
    margin-right: 4%;
  }
  </style>